import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { WatchTrailer } from "..";
import { LINKS } from "../../utils/constants/links";
import { getTruncatedAddress } from "../../utils/helpers/functions";
import {
  LANDSALE_LOGO,
  home,
  closeDark,
  videoPlayIcon,
} from "../../assets/index";
import "./Header.css";
import CustomLoader from "../../layout/CustomLoader";
import { Spinner } from "react-bootstrap";

const Header = ({
  openWalletModal,
  showInvetory = false,
  account = null,
  goToInventary,
  gotToClaim,
  gotToKnowMore,
  goToMap,
  isConnecting = false,
}) => {
  const [expireModel, setExpireModel] = useState(false);
  const toggleVideoModal = (toggle) => {
    setExpireModel(toggle);
  };

  return (
    <React.Fragment>
      <header className="fixed-top" style={{ padding: 0 }}>
        <div
          id="mainTimer"
          className="deedsTimer w-100"
          style={{ display: "none" }}
        >
          <div className="deed d-flex">
            <span id="slotMsg" className="time"></span>
            <div
              id="slotTimer"
              className="dInlineBlock timer pl--10 timer-visibility"
            ></div>
          </div>
        </div>
        
        <nav className="navbar navbar-expand-lg navbar-dark">
          <div className="container-fluid pl--0 pr--0">
            <div className="nav-left">
              <a href="https://virtua.com/" className="nav-home">
                <img src={home} alt="" />
              </a>
              <Link to={LINKS.HOME} className="navbar-brand" href="#">
                <img
                  src={LANDSALE_LOGO}
                  className="img img-fluid"
                  alt="land-sale"
                />
                <span></span>
              </Link>
            </div>
            <div className="mobile-right-menu">
              {account ? (
                <button
                  className="custom-btn accent-outline lg uppercase mr--15 connectbtn"
                  onClick={openWalletModal}
                >
                  {getTruncatedAddress(account)}
                </button>
              ) : (
                <button
                  className="custom-btn accent-bg lg uppercase mr--15"
                  onClick={openWalletModal}
                  id="wallet-connect-btn"
                >
                  Connect Wallet
                </button>
              )}
              {/* <button
                className="custom-btn accent-bg lg uppercase mr--15"
                onClick={openWalletModal}
              >
                {getTruncatedAddress(account) ?? "Connect Wallet"}
              </button> */}
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasTop"
                aria-controls="offcanvasTop"
              >
                <svg
                  width="22"
                  height="16"
                  viewBox="0 0 22 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 15L21 15M11 8H21M1 1H21"
                    stroke="#F8F8F8"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>

            <div
              className="collapse navbar-collapse justify-content-end"
              id="navbarNav"
            >
              <ul className="navbar-nav">
                {(window.location.pathname.includes("/inventory") ||
                  window.location.pathname.includes("/faqs")) && (
                  <li className="nav-item">
                    <button
                      type="button"
                      className="btn custom-btn icon-btn lg accent-outline uppercase"
                      onClick={() => goToMap()}
                    >
                      Monster Zone
                    </button>
                  </li>
                )}
                {/* <li className="nav-item">
                  <a
                    href="https://island.virtua.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="custom-btn light-outline lg uppercase"
                    onClick={gotToKnowMore}
                  >
                    <span className="txt">KNOW MORE</span>
                  </a>
                </li> */}
                {showInvetory && (
                  <li className="nav-item">
                    <button
                      type="button"
                      className="btn custom-btn icon-btn lg accent-outline uppercase"
                      onClick={goToInventary}
                    >
                      My Inventory
                    </button>
                  </li>
                )}
                <li className="nav-item" style={{ display: "none" }}>
                  <button
                    type="button"
                    className="custom-btn light-bg lg uppercase"
                    onClick={gotToClaim}
                    disabled
                  >
                    <span className="txt">CLAIM REWARDS</span>
                  </button>
                </li>

                <li className="nav-item">
                  {account ? (
                    <button
                      className="custom-btn accent-outline lg uppercase connectbtn"
                      onClick={openWalletModal}
                    >
                      {getTruncatedAddress(account)}
                    </button>
                  ) : (
                    <button
                      className="custom-btn accent-bg lg uppercase"
                      onClick={openWalletModal}
                      style={{ width: 200 }}
                    >
                      {isConnecting ? <Spinner size="sm" /> : "Connect Wallet"}
                    </button>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <div
          className="mobile-offset-menu offcanvas offcanvas-top"
          tabIndex="-1"
          id="offcanvasTop"
          aria-labelledby="offcanvasTopLabel"
        >
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <img src={closeDark} alt="close" />
          </button>
          <ul className="navbar-nav">
            {(window.location.pathname.includes("/inventory") ||
              window.location.pathname.includes("/faqs")) && (
              <li className="nav-item">
                <button
                  type="button"
                  className="custom-btn light-outline lg uppercase"
                  onClick={() => goToMap()}
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Monster Zone
                </button>
              </li>
            )}
            {/* <li className="nav-item">
              <a
                href="https://island.virtua.com/"
                target="_blank"
                rel="noreferrer"
                className="custom-btn light-outline lg uppercase"
                onClick={gotToKnowMore}
              >
                <span className="txt">KNOW MORE</span>
              </a>
            </li> */}
            {showInvetory && (
              <li className="nav-item">
                <button
                  type="button"
                  className="custom-btn light-outline lg uppercase inventoryBtn"
                  onClick={goToInventary}
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  My Inventory
                </button>
              </li>
            )}
            <li className="nav-item" style={{ display: "none" }}>
              <button
                type="button"
                className="custom-btn light-outline lg uppercase"
                onClick={gotToClaim}
                disabled
              >
                <span className="txt">CLAIM REWARDS</span>
              </button>
            </li>
            <li className="nav-item">
              <button
                className="custom-btn light-outline md"
                onClick={() => window.open("/monsterzone/faqs", "_blank")}
              >
                FAQs
              </button>
            </li>
            <li className="nav-item">
              <button
                className="custom-btn light-outline lg"
                onClick={toggleVideoModal}
              >
                <img src={videoPlayIcon} alt="video play" />
                <span className="btn-txt">How it Works?</span>
              </button>
            </li>
          </ul>
        </div>
       
      </header>
      <div>
      {expireModel && (
        <WatchTrailer open={expireModel} setOpen={toggleVideoModal} />
      )}
      </div>
    </React.Fragment>
  );
};

export default Header;
